<template src="./template.html"></template>

<script>
import Vue from 'vue'
import HASONBASHO from 'src/consts/hasonbasho'
import masterMixin from 'src/mixins/masterMixin'
import notificationMixin from 'src/mixins/notificationMixin'
import poleMixin from 'src/mixins/poleMixin'
import tenkenDataBaseApi from 'src/apis/tenken_data_base'
import tenkenDataDetailApi from 'src/apis/tenken_data_roka'

export default {
  displayPageName: '詳細結果入力',
  data() {
    return {
      tdd: null,

      photoSelectorModalTitle: '写真選択',

      showPhotoSelectorModal: false,
      showSaveModal: false,
      showBeforeBackModal: false,

      ukeoigyoushaCands: [],
      staffCands: [],
      tantoujimushoCands: [],
      tenkenKubunCands: [],
      tekiyouCands: [],
      rosenCands: [],
      rosenHoukouCands: [],
      hasonbashoCands: [],
      hanteiCands: [],

      isRequesting: false,

      bgColorFlgInfo: {},
    }
  },
  computed: {
    isNew() {
      return this.$route.path.endsWith('/new')
    },
    usedPhotos() {
      const photos = this.tdd.photos
      if (!photos || photos.length === 0) { return [] }
      return photos
        .filter(e => e.is_used)
        .slice().sort((a, b) => a.disp_order - b.disp_order)
    }
  },
  async mounted() {
    const promises = [
      this.ensureUserAndMasters(),
      this.getTenkenDataDetail(),
    ]
    await Promise.all(promises)
    this.prepareMasters()
    if (this.isNew) {
      // 担当事務所をセットする
      if (this.tantoujimushoCands.length > 0) {
        this.tdd.jimusho_id =
          this.tantoujimushoCands[0].m_tantoujimusho_id
      }
    }
  },
  mixins: [masterMixin, notificationMixin, poleMixin],
  methods: {
    getTenkenDataDetailForDisp(tdd) {
      // alias
      tdd.tdb = tdd.tenken_data_base
      // 発見時間
      if (tdd.hakkenjikan) {
        const hm = tdd.hakkenjikan.split(':')
        tdd.hakkenjikan_h = hm[0]
        tdd.hakkenjikan_m = hm[1]
      }
      // 写真
      if (tdd.photos.length > 0) {
        tdd.photos.forEach(e => {
          e.src = e.signed_id // alias
        })
      }
      return tdd
    },
    async getTenkenDataDetail() {
      let tdd = {}
      if (this.isNew) {
        const { data } = await tenkenDataBaseApi.show(this.$route.params.base_id)
        tdd.base_id = data.base_id
        tdd.detail_gyoumu_id = this.$route.query.detail_gyoumu_id
        tdd.tenken_data_base = data
        tdd.photos = []
        tdd = this.getTenkenDataDetailForDisp(tdd)
      } else {
        const { data } = await tenkenDataDetailApi.show(this.$route.params.detail_id)
        tdd = this.getTenkenDataDetailForDisp(data)
      }
      this.tdd = tdd
    },
    filterByGyoumu(items) {
      const tdd = this.tdd
      return items.filter(e => {
        return (e.tenkengyoumu_base_id === tdd.tdb.tenken_gyoumu_id) &&
          (e.tenkengyoumu_detail_id === tdd.detail_gyoumu_id)
      })
    },
    filterByTenkenDate(items) {
      const dt = new Date(this.tdd.tdb.tenken_date)
      return items.filter(e => {
        const startDt = new Date(e.start_date)
        const endDt = new Date(new Date(e.end_date).valueOf() + 86400 * 1000)
        return (startDt <= dt) && (dt < endDt)
      })
    },
    prepareMasters() {
      const master = window.master
      // 点検請負者
      this.ukeoigyoushaCands = master.ukeoigyousha.vals
      // 点検責任者, 点検員
      this.staffCands = master.staff.vals
      // 担当事務所
      let tantoujimushoCands = this.tdd.tdb.rosen.tantoujimusho_list
      tantoujimushoCands = tantoujimushoCands
        .filter(e => e.detail_gyoumu_id === this.tdd.detail_gyoumu_id)
      tantoujimushoCands = this.filterByTenkenDate(tantoujimushoCands)
      this.tantoujimushoCands = tantoujimushoCands
      // 点検区分
      let tenkenKubunCands = master.tenken_kubun.vals
      tenkenKubunCands = this.filterByGyoumu(master.tenken_kubun.vals)
      tenkenKubunCands = this.filterByTenkenDate(tenkenKubunCands)
      this.tenkenKubunCands = tenkenKubunCands
      // 摘要欄
      this.tekiyouCands = master.tekiyou.vals
      // 路線
      this.rosenCands = master.rosen.vals
      // 路線方向
      this.rosenHoukouCands = master.rosen_houkou.vals
        .filter(e => e.rosen_id === this.tdd.tdb.rosen_id)
      // 破損場所
      this.hasonbashoCands = master.hasonbasho.vals
      // 判定
      this.hanteiCands = this.filterByTenkenDate(master.hantei.vals)
    },
    async setDataByPhotoGeoInfo(photo) {
      if (this.usedPhotos.length > 1) { return }

      const metadata = photo.metadata
      if (!metadata) { return }

      const tdd = this.tdd
      const bgColorFlgInfo = {}

      const datetime = metadata.datetime
      const lat = metadata.latitude
      const lon = metadata.longitude
      const geoLocations = metadata.geo_locations

      // 緊急通報から切り出した場合は、動画から取得したポール情報をmetadataに入れてある
      let pole = metadata.pole
      if (!pole) {
        // 写真の位置情報をもとにポールを取得
        pole = await this.getPoleByGeoInfo(lat, lon, geoLocations)
      }

      if (lat !== '' && lon !== '') {
        tdd.location_info = { lat, lon }
      }
      if (datetime) {
        const dtFormat = Vue.filter('dtFormat')
        const dt = new Date(datetime)
        tdd.hakkenjikan_h = dtFormat(dt, 'HH')
        tdd.hakkenjikan_m = dtFormat(dt, 'MM')
        bgColorFlgInfo.hakkenjikan = true
      }
      if (pole) {
        const rosenHoukou = this.rosenHoukouCands
          .find(e => e.name === pole.direction)
        const hasonbasho = this.hasonbashoCands
          .find(e => parseInt(e.m_hasonbasho_id) === HASONBASHO.POLE)
        const hasonbashoNo = this.getPoleNoInputFormat(pole.code)

        if (rosenHoukou) {
          tdd.houkou_id = rosenHoukou.m_rosen_houkou_id
          bgColorFlgInfo.houkouId = true
        }
        if (hasonbasho) {
          tdd.hasonbasho_id = hasonbasho.m_hasonbasho_id
          bgColorFlgInfo.hasonbashoId = true
        }
        if (hasonbashoNo) {
          tdd.hasonbasho_no = hasonbashoNo
          bgColorFlgInfo.hasonbashoNo = true
        }
      }

      this.tdd = tdd
      this.bgColorFlgInfo = bgColorFlgInfo
    },
    getTenkenDataDetailForReq() {
      const ret = this.tdd
      // 発見時間
      const hStr = ret.hakkenjikan_h
      const mStr = ret.hakkenjikan_m
      let hakkenjikan = null
      if (!!hStr && !!mStr) {
        hakkenjikan = `${hStr}:${mStr}`
      }
      ret.hakkenjikan = hakkenjikan
      return ret
    },
    getPhotosForReq() {
      const formData = new FormData()
      for (const photo of this.tdd.photos) {
        formData.append('photos[][id]', photo.id)
        formData.append('photos[][is_used]', photo.is_used)
        formData.append('photos[][disp_order]', photo.disp_order)
        if (photo.isNew) {
          const metadata = photo.metadata
          formData.append('photos[][file]', photo.file, photo.filename)
          formData.append('photos[][metadata][datetime]', metadata.datetime)
          formData.append('photos[][metadata][latitude]', metadata.latitude)
          formData.append('photos[][metadata][longitude]', metadata.longitude)
          formData.append('photos[][metadata][geo_locations]', metadata.geo_locations)
        }
      }
      return formData
    },
    async openSaveModal() {
      const isValid = await this.$refs.tdd.validate()
      if (!isValid) { return }

      this.showSaveModal = true
    },
    async saveTenkenDataDetail() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        if (this.isNew) {
          await this._createTenkenDataDetail()
        } else {
          await this._updateTenkenDataDetail()
        }
        this.showSaveModal = false
        this.notifySuccess1('詳細結果を保存しました。')
        this.isRequesting = false
      } catch (err) {
        const msg = '詳細結果の保存に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
    async _createTenkenDataDetail() {
      try {
        const reqObj1 = this.getTenkenDataDetailForReq()
        const reqObj2 = this.getPhotosForReq()
        const { data } = await tenkenDataDetailApi.create(reqObj1)
        await tenkenDataDetailApi.bulkUpdatePhotos(data.detail_id, reqObj2)
        this.$router.replace({
          name: 'RokaTenkenDetail',
          params: { detail_id: data.detail_id }
        })
      } catch (err) {
        console.error('error', err)
        throw err
      }
    },
    async _updateTenkenDataDetail() {
      try {
        const id = this.tdd.detail_id
        const reqObj1 = this.getTenkenDataDetailForReq()
        const reqObj2 = this.getPhotosForReq()
        await tenkenDataDetailApi.update(id, reqObj1)
        await tenkenDataDetailApi.bulkUpdatePhotos(id, reqObj2)
        await this.getTenkenDataDetail()
      } catch (err) {
        console.error('error', err)
        throw err
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
